import { useState, useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { createNewBoxValidation } from "../../../../validations/leitnerValidation";
import {
  checkResponseData,
  customToastify,
  LoadingSvg,
} from "../../../utils/utils";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { Formik, Field, Form, ErrorMessage } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import {
  Button,
  TextField,
  FormHelperText,
  Typography,
  Divider,
} from "@mui/material";

export default function EditBox(props) {
  const { boxInfo, handleEditBox, updateInfo } = props;
  const [info, setInfo] = useState({
    boxId: "",
    name: "",
    fromLang: "",
    toLang: "",
    description: "",
  });

  const handleInfoValue = (data) => {
    setInfo({ ...info, ...data });
  };

  let initialValues = {
    boxId: boxInfo["_id"],
    name: boxInfo["name"],
    fromLang: boxInfo["fromLang"],
    toLang: boxInfo["toLang"],
    description: boxInfo["description"],
  };
  const onSubmit = (values, props) => {
    const newvalue = { boxId: boxInfo["_id"], ...values };
    updateInfo(newvalue);
  };
  useEffect(() => {
    if (boxInfo["_id"]) {
      const { name, fromLang, toLang, description } = boxInfo;
      setInfo({ boxId: boxInfo["_id"], name, fromLang, toLang, description });
    }
  }, [boxInfo]);

  return (
    <>
      {boxInfo == "loading" || !boxInfo["_id"] ? (
        <Box sx={{ textAlign: "center", my: 1.5 }}>
          <Typography>لطفا صبر کنید</Typography>
          <LoadingSvg />
        </Box>
      ) : (
        <>
          <Formik
            initialValues={initialValues}
            validationSchema={createNewBoxValidation}
            onSubmit={onSubmit}
          >
            {(props) => (
              <Form>
                <Divider
                  sx={{
                    textAlign: "center",
                    color: (theme) =>
                      theme.palette.reverse.status == "dark"
                        ? "goldenrod"
                        : "blue",
                  }}
                >
                  {"نام لایتنر"}
                </Divider>
                <Box sx={{ textAlign: "center", mb: 1 }}>
                  <Field
                    as={TextField}
                    sx={{ mx: 1, my: 1 }}
                    type="text"
                    name="name"
                    value={info["name"]}
                    label="نام لایتنر"
                    placeholder="نام لایتنر"
                    onChange={(e) => {
                      props.setFieldValue("name", e.target.value);
                      handleInfoValue({ name: e.target.value });
                    }}
                  />
                  <FormHelperText
                    sx={{ m: 0, p: 0, color: "#f96767", textAlign: "center" }}
                  >
                    <ErrorMessage name="name" />
                  </FormHelperText>
                </Box>
                <Divider
                  sx={{
                    textAlign: "center",
                    color: (theme) =>
                      theme.palette.reverse.status == "dark"
                        ? "goldenrod"
                        : "blue",
                  }}
                >
                  {"زبان اصلی"}
                </Divider>
                <Box sx={{ textAlign: "center", mb: 1 }}>
                  <FormControl style={{ minWidth: 170, margin: "5px" }}>
                    <InputLabel id="demo-simple-select-label">
                      زبان اصلی
                    </InputLabel>
                    <Select
                      label="fromLang"
                      name="fromLang"
                      value={info["fromLang"]}
                      id="fromLang"
                      defaultValue=""
                      onChange={(e) => {
                        props.setFieldValue("fromLang", e.target.value);
                        handleInfoValue({ fromLang: e.target.value });
                      }}
                    >
                      <MenuItem
                        sx={{
                          color: (theme) =>
                            theme.palette.reverse.menuItemReverse,
                        }}
                        autoFocus
                        key={0}
                        value="en"
                      >
                        English
                      </MenuItem>
                      <MenuItem
                        sx={{
                          color: (theme) =>
                            theme.palette.reverse.menuItemReverse,
                        }}
                        key={1}
                        asdasd="asdasd"
                        value="de"
                      >
                        German
                      </MenuItem>
                      <MenuItem
                        sx={{
                          color: (theme) =>
                            theme.palette.reverse.menuItemReverse,
                        }}
                        key={2}
                        value="fr"
                      >
                        French
                      </MenuItem>
                      <MenuItem
                        sx={{
                          color: (theme) =>
                            theme.palette.reverse.menuItemReverse,
                        }}
                        key={3}
                        value="it"
                      >
                        Italian
                      </MenuItem>
                      <MenuItem
                        sx={{
                          color: (theme) =>
                            theme.palette.reverse.menuItemReverse,
                        }}
                        key={4}
                        value="ar"
                      >
                        Arabic
                      </MenuItem>
                      <MenuItem
                        sx={{
                          color: (theme) =>
                            theme.palette.reverse.menuItemReverse,
                        }}
                        key={5}
                        value="fa"
                      >
                        Persian
                      </MenuItem>
                      {Object.keys(languagesList).map((option, index) => (
                        <MenuItem key={index + 6} value={option}>
                          {languagesList[option]}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      sx={{ color: "#f96767", textAlign: "center" }}
                    >
                      <ErrorMessage name="fromLang" />
                    </FormHelperText>
                  </FormControl>
                </Box>
                <Divider
                  sx={{
                    textAlign: "center",
                    color: (theme) =>
                      theme.palette.reverse.status == "dark"
                        ? "goldenrod"
                        : "blue",
                  }}
                >
                  {"زبان ترجمه"}
                </Divider>
                <Box sx={{ textAlign: "center", mb: 1 }}>
                  <FormControl style={{ minWidth: 170, margin: "5px" }}>
                    <InputLabel id="demo-simple-select-label">
                      زبان ترجمه
                    </InputLabel>
                    <Select
                      label="toLang"
                      name="toLang"
                      value={info["toLang"]}
                      id="toLang"
                      defaultValue=""
                      onChange={(e) => {
                        props.setFieldValue("toLang", e.target.value);
                        handleInfoValue({ toLang: e.target.value });
                      }}
                    >
                      <MenuItem
                        sx={{
                          color: (theme) =>
                            theme.palette.reverse.menuItemReverse,
                        }}
                        autoFocus
                        key={0}
                        value="en"
                      >
                        English
                      </MenuItem>
                      <MenuItem
                        sx={{
                          color: (theme) =>
                            theme.palette.reverse.menuItemReverse,
                        }}
                        key={1}
                        asdasd="asdasd"
                        value="de"
                      >
                        German
                      </MenuItem>
                      <MenuItem
                        sx={{
                          color: (theme) =>
                            theme.palette.reverse.menuItemReverse,
                        }}
                        key={2}
                        value="fr"
                      >
                        French
                      </MenuItem>
                      <MenuItem
                        sx={{
                          color: (theme) =>
                            theme.palette.reverse.menuItemReverse,
                        }}
                        key={3}
                        value="it"
                      >
                        Italian
                      </MenuItem>
                      <MenuItem
                        sx={{
                          color: (theme) =>
                            theme.palette.reverse.menuItemReverse,
                        }}
                        key={4}
                        value="ar"
                      >
                        Arabic
                      </MenuItem>
                      <MenuItem
                        sx={{
                          color: (theme) =>
                            theme.palette.reverse.menuItemReverse,
                        }}
                        key={5}
                        value="fa"
                      >
                        Persian
                      </MenuItem>
                      {Object.keys(languagesList).map((option, index) => (
                        <MenuItem key={index + 6} value={option}>
                          {languagesList[option]}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      sx={{ color: "#f96767", textAlign: "center" }}
                    >
                      <ErrorMessage name="toLang" />
                    </FormHelperText>
                  </FormControl>
                </Box>
                <Divider
                  sx={{
                    textAlign: "center",
                    color: (theme) =>
                      theme.palette.reverse.status == "dark"
                        ? "goldenrod"
                        : "blue",
                  }}
                >
                  {"توضیحات"}
                </Divider>
                <Box sx={{ textAlign: "center", mb: 1 }}>
                  <Field
                    as={TextField}
                    sx={{ mx: 1, mb: 1 }}
                    type="text"
                    name="description"
                    multiline={true}
                    label="توضیحات"
                    value={info["description"]}
                    placeholder="توضیحات"
                    minRows={3}
                    onChange={(e) => {
                      props.setFieldValue("description", e.target.value);
                      handleInfoValue({ description: e.target.value });
                    }}
                  />
                  <FormHelperText
                    sx={{ m: 0, p: 0, color: "#f96767", textAlign: "center" }}
                  >
                    <ErrorMessage name="description" />
                  </FormHelperText>
                </Box>

                <Box
                  sx={{
                    mx: 1,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{ mx: 2 }}
                    onClick={() => {
                      handleEditBox();
                    }}
                    color="error"
                  >
                    لغو
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ mx: 2 }}
                    color="success"
                  >
                    ذخیره
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
          {/* <Divider
            sx={{
              textAlign: "center",
              color: (theme) =>
                theme.palette.reverse.status == "dark" ? "goldenrod" : "blue",
            }}
          >
            {"نام لایتنر"}
          </Divider>
          <Box sx={{ textAlign: "center", mb: 1 }}>
            <Typography>{info["name"] || <LoadingSvg />}</Typography>
          </Box>
          <Divider
            sx={{
              textAlign: "center",
              color: (theme) =>
                theme.palette.reverse.status == "dark" ? "goldenrod" : "blue",
            }}
          >
            {"زبان اصلی"}
          </Divider>
          <Box sx={{ textAlign: "center", mb: 1 }}>
            <Typography>{info["fromLang"] || <LoadingSvg />}</Typography>
          </Box>
          <Divider
            sx={{
              textAlign: "center",
              color: (theme) =>
                theme.palette.reverse.status == "dark" ? "goldenrod" : "blue",
            }}
          >
            {"زبان ترجمه"}
          </Divider>
          <Box sx={{ textAlign: "center", mb: 1 }}>
            <Typography>{info["toLang"] || <LoadingSvg />}</Typography>
          </Box>
          <Divider
            sx={{
              textAlign: "center",
              color: (theme) =>
                theme.palette.reverse.status == "dark" ? "goldenrod" : "blue",
            }}
          >
            {"توضیحات"}
          </Divider>
          <Box sx={{ textAlign: "center", mb: 1 }}>
            <Typography>{info["description"] || <LoadingSvg />}</Typography>
          </Box> */}
        </>
      )}
    </>
  );
}

const languagesList = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari languages",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  km: "Central Khmer",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  ki: "Gikuyu, Kikuyu",
  el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  rw: "Kinyarwanda",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kwanyama, Kuanyama",
  ku: "Kurdish",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "Northern Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  se: "Northern Sami",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  pa: "Panjabi, Punjabi",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Sotho, Southern",
  nr: "South Ndebele",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volap_k",
  wa: "Walloon",
  cy: "Welsh",
  fy: "Western Frisian",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu",
};
